import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import {SET_ORDERS_ERROR} from "./orders.module";
import JwtService from "@/core/services/jwt.service";

export const GET_SETTINGS = "getSettings";
export const UPDATE_SETTINGS = "updateSettings";
export const SET_SETTINGS = "setSettings";
export const SET_SETTINGS_LOAD = "setSettingsLoad";
export const SET_SETTINGS_ERROR = "setSettingsErrors";

const state = {

    errors: {},

    settings: {
        dollar_rate: 1,
    },

    load: true,

};

const getters = {
    gettersSettingSite(state) {
        return state.settings;
    },

    getSettingSiteLoad(){
        return state.load;
    },

    getSettingErrors(){
        return state.errors;
    }
};

const actions = {


    [GET_SETTINGS](context, id) {
        context.commit(SET_SETTINGS_LOAD, true);
        context.commit(SET_ORDERS_ERROR, {});
        ApiService.get("/site-settings", id)
            .then(({ data }) => {
                context.commit(SET_SETTINGS, data);
                context.commit(SET_SETTINGS_LOAD, false);
            })
            .catch(({ response }) => {
                context.commit(SET_SETTINGS_ERROR, response.data.errors);
                context.commit(SET_SETTINGS_LOAD, false);
            });
    },


    [UPDATE_SETTINGS](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_SETTINGS_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.put("/site-settings/update", data)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_SETTINGS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_SETTINGS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    }


};

const mutations = {

    [SET_SETTINGS](state, data) {
        state.settings = data;
    },

    [SET_SETTINGS_LOAD](state, load) {
        state.load = load;
    },

    [SET_SETTINGS_ERROR](state, error) {
        state.errors = error;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
